import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");

  if (!token || !allowedRoles.includes(role)) {
    if (allowedRoles.includes("admin")) 
      return <Navigate to="/admin-signin" replace />;

    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
